import { isOfType } from "../../../../utils";

// https://citrineinformatics.github.io/gemd-docs/specification/value-types/#molecular-structure
export interface ISmilesValue {
  type: "smiles";
  smiles: string;
}

export const isSmilesValue = isOfType<ISmilesValue>("smiles");

export const smilesValueToString = (smilesValue: ISmilesValue): string => {
  // TODO might have to format this in a special way so it doesn't look like a plain string
  return smilesValue.smiles;
};
